import React, { memo } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
// Local files
import useCustomSelector from 'hooks/useCustomSelector';
import useSuccess from 'hooks/useSuccess';
import { successSelectors } from 'features/success';

const SuccessSnackbar = () => {
  const { hideSuccess } = useSuccess();
  const { open, message } = useCustomSelector(successSelectors.getSuccessData);

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      open={open}
      autoHideDuration={5000}
      onClose={hideSuccess}
    >
      <Alert
        icon={false}
        onClose={hideSuccess}
        sx={{
          color: '#fff',
          backgroundColor: 'info.main',
          borderRadius: '2px',
          fontSize: '0.75rem'
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default memo(SuccessSnackbar);